module.exports = __webpack_public_path__ + "assets/img/young-doctors-m.04ed81e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/topics/young-doctors-m.jpg
// module id = 7PdY
// module chunks = 0